module.exports = __webpack_public_path__ + "img/video-off.3391f165.svg";